module.exports = __webpack_public_path__ + "img/rule-en.fe2caaa2.png";